import { Component, Input } from '@angular/core';
import { SharedCSSPropertyName } from '@app/eds';

// eslint-disable-next-line @typescript-eslint/naming-convention
export type TextType =
  | 'headline1'
  | 'headline2'
  | 'headline2-inherit'
  | 'headline3'
  | 'headline4'
  | 'headline5'
  | 'headline6'
  | 'subhead1'
  | 'subhead2'
  | 'body'
  | 'body1'
  | 'body2'
  | 'body3'
  | 'tertiary'
  | 'tertiary-red'
  | 'caption'
  | 'overline'
  | 'overline-yellow'
  | 'button-regular'
  | 'table-header'
  | 'mobile-overline'
  | 'big-heading'
  | 'big-subheading'
  | 'big-subheading1'
  | 'table-column-bold'
  | 'table-column-title'
  | 'table-column-uppercase'
  | 'table-column'
  | 'table-column-uppercase'
  | 'headline2-bold'
  | 'body2-bold'
  | 'headline5-bold'
  | 'headline3-gap-line-20'
  | 'nav-option';

@Component({
  selector: 'app-text [textStyleType]',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss']
})
export class TextComponent {
  // tells us the different text style types
  @Input() textStyleType!: TextType;

  // Optional Style for rendering style
  @Input() public style!: { [key: string]: string };

  // optional value which tells us whether to preserve or remove white spaces
  @Input() whiteSpaceValue!: string;

  getClassName = (): string => {
    switch (this.textStyleType) {
      case 'headline1':
        return 'h1';
      case 'headline2':
        return 'h2';
      case 'headline2-inherit':
        return 'h2-inherit';
      case 'headline3':
        return 'h3';
      case 'headline4':
        return 'h4';
      case 'headline5':
        return 'h5';
      case 'headline6':
        return 'h6';
      case 'subhead1':
        return 'subhead1';
      case 'subhead2':
        return 'subhead2';
      case 'tertiary':
        return 'tertiary-item';
      case 'tertiary-red':
        return 'tertiary-item-red';
      case 'body':
        return 'body';
      case 'body1':
        return 'body1';
      case 'body2':
        return 'body2';
      case 'body3':
        return 'body3';
      case 'caption':
        return 'caption';
      case 'overline':
        return 'overline';
      case 'overline-yellow':
        return 'overline-yellow';
      case 'button-regular':
        return 'button-regular';
      case 'table-header':
        return 'table-header';
      case 'mobile-overline':
        return 'mobile-overline';
      case 'big-heading':
        return 'big-heading';
      case 'big-subheading':
        return 'big-subheading';
      case 'big-subheading1':
        return 'big-subheading1';
      case 'table-column-bold':
        return 'table-column-bold';
      case 'table-column-title':
        return 'table-column-title';
      case 'table-column-uppercase':
        return 'table-column-uppercase';
      case 'table-column':
        return 'table-column';
      case 'headline2-bold':
        return 'headline2-bold';
      case 'body2-bold':
        return 'body2-bold';
      case 'headline5-bold':
        return 'h5-bold';
      case 'headline3-gap-line-20':
        return 'h3-gap-line-20';
      case 'nav-option':
        return 'nav-option';
      default:
        return 'body1';
      
    }
  };

  /**
   * This method will return custom styles
   *
   * @returns { [key: string]: string } stylingObj
   */
  getStyles = () => {
    const stylingObj: { [key: string]: string } = this.style ? { ...this.style } : {};
    if (this.whiteSpaceValue) {
      stylingObj[SharedCSSPropertyName.WHITE_SPACE] = this.whiteSpaceValue;
    }
    return stylingObj;
  };
}
